import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { PageHeader } from '@/components/ui/page-header';
import { useAuth } from '@/contexts/AuthContext';
import DashboardOverview from '@/components/dashboard/DashboardOverview';
import SmartRecommendations from '@/components/dashboard/SmartRecommendations';
import QuickActions from '@/components/dashboard/QuickActions';
import RecentActivity from '@/components/dashboard/RecentActivity';
import { SubscriptionUsageWidget } from '@/components/dashboard/SubscriptionUsageWidget';
import OnboardingStepper from '@/components/dashboard/OnboardingStepper';
import EngagementROIWidget from '@/components/dashboard/EngagementROIWidget';

const Dashboard = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-lg">Chargement...</div>
      </div>
    );
  }

  if (!user) {
    return null; // useAuth will handle redirect
  }

  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      
      <PageHeader 
        title="Mon espace"
        description="Votre centre de contrôle pour développer votre réseau, saisir les opportunités et maximiser votre impact"
      />
      
      <main>
        <section className="py-8 sm:py-12">
          <div className="container mx-auto px-3 sm:px-4 max-w-7xl space-y-6">
            {/* Onboarding stepper for new members */}
            <OnboardingStepper />
            
            {/* Overview stats */}
            <DashboardOverview />
            
            {/* Main dashboard grid */}
            <div className="grid gap-6 lg:grid-cols-3">
              {/* Smart recommendations - 2 columns on desktop */}
              <div className="lg:col-span-2 order-2 lg:order-1">
                <SmartRecommendations />
              </div>
              
              {/* Quick actions and subscription widget - 1 column */}
              <div className="lg:col-span-1 space-y-6 order-1 lg:order-2">
                <QuickActions />
                <EngagementROIWidget />
                <SubscriptionUsageWidget />
              </div>
            </div>
            
            {/* Recent activity */}
            <RecentActivity />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Dashboard;